import { render, staticRenderFns } from "./projectApplication.vue?vue&type=template&id=72ce9440&scoped=true"
import script from "./projectApplication.vue?vue&type=script&lang=js"
export * from "./projectApplication.vue?vue&type=script&lang=js"
import style0 from "./projectApplication.vue?vue&type=style&index=0&id=72ce9440&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce9440",
  null
  
)

export default component.exports